import App from 'app';
import AppConfig from 'utils/app-config';
import store from 'store';
import Vuelidate from 'vuelidate';
import VueTheMask from 'vue-the-mask';
import VModal from 'vue-js-modal';
import VuePaginate from 'vue-paginate';
import Router from 'build/router';
import VueClipboard from 'vue-clipboard2';
import pageLoader from 'components/zilla/page-loader';
import Toast from 'components/zilla/toast';
import vClickOutside from 'v-click-outside';

// Ícones FontAwesome (`fal fa-*`, `fas fa-*`) desenhados pelo catálogo do Zilla, no lugar do kit da Font Awesome
import '@quero/zilla-icons-fa-fontawesome-pro/css/all.css';

// plugins
import filters from 'plugins/filters';
import rollbar from 'plugins/rollbar';
import tracker from 'plugins/tracker';
import gambit from 'plugins/gambit';
import zillaPlugin from 'plugins/zilla-plugin';
import firebase from 'plugins/firebase';

const BillingStudentDashboard = {
  install(Vue, {
    authToken, mountPath, impersonatingUserId, standalone, facebookId, firebaseVapidKey, googleId,
  }) {
    if ('serviceWorker' in navigator) {
      const promptEvent = new Promise((resolve) => {
        window.addEventListener('beforeinstallprompt', (event) => {
          event.preventDefault();
          resolve(event);
        });
      });

      Vue.prototype.$promptEvent = promptEvent;

      navigator.serviceWorker.register('service-worker.js');
    }

    // Define globals
    AppConfig.merge({
      authToken,
      mountPath,
      impersonatingUserIdFromQb: impersonatingUserId,
      standalone,
      facebookId,
      firebaseVapidKey,
      googleId,
    });

    Vue.use(VueTheMask);
    Vue.use(Vuelidate);
    Vue.use(VModal, {
      dialog: true,
      dynamic: true,
    });
    Vue.use(VuePaginate);
    Vue.use(store);
    Vue.use(VueClipboard);
    Vue.use(pageLoader);
    Vue.use(vClickOutside);

    Object.defineProperty(Vue.prototype, '$config', {
      get() {
        return AppConfig;
      },
    });

    Vue.use(Router, { standalone, mountPath });
    Vue.use(Toast);

    // plugins
    Vue.use(filters);
    Vue.use(rollbar);
    Vue.use(tracker);
    Vue.use(gambit);
    Vue.use(zillaPlugin);
    Vue.use(firebase);

    Vue.config.errorHandler = (error) => {
      if (AppConfig.environment === 'production') {
        Vue.$rollbar.error(error);
      } else {
        console.error(error);
      }
    };

    Vue.component('StudentDashboard', App);
  },
};

export default BillingStudentDashboard;
